import { CommonModule } from '@angular/common';
import { InjectionToken, NgModule } from '@angular/core';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { TranslocoModule } from '@jsverse/transloco';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { AbandonedReservationComponent } from '@abandoned-reservation/abandoned-reservation.container';
import { UserHistoryService } from '@user-history/services/user-history.service';
import {
  AbandonedFlightReservationComponent
} from '@abandoned-reservation/components/abandoned-flight-reservation/abandoned-flight-reservation.component';
import {
  AbandonedAutoReservationComponent
} from '@abandoned-reservation/components/abandoned-auto-reservation/abandoned-auto-reservation.component';
import {
  AbandonedHotelReservationComponent
} from '@abandoned-reservation/components/abandoned-hotel-reservation/abandoned-hotel-reservation.component';
import {
  AbandonedReservationHeaderComponent
} from '@abandoned-reservation/components/abandoned-reservation-header/abandoned-reservation-header.component';
import { HotelSegmentDetail } from '@shared/hotel-segment-detail/hotel-segment-detail.module';
import { ImageModule } from '@ux/components/image/image.module';
import {
  AbandonedReservationActionsComponent
} from '@abandoned-reservation/components/abandoned-reservation-actions/abandoned-reservation-actions.component';
import { FlightItineraryModule } from '@shared/flight-itinerary/flight-itinerary.module';
import { AutoReservationComponent } from '@abandoned-reservation/components/auto-reservation/auto-reservation.component';
import {
  AbandonedAirPackageReservationComponent
} from '@abandoned-reservation/components/abandoned-air-package-reservation/abandoned-air-package-reservation.component';
import { AbandonedReservationService } from '@abandoned-reservation/services/abandoned-reservation.service';
import {
  abandonedReservationFeatureName, AbandonedReservationState
} from '@abandoned-reservation/store/state/abandoned-reservation.state';
import { abandonedReservationRootReducer } from '@abandoned-reservation/store/reducers';
import { AbandonedReservationEffect } from '@abandoned-reservation/store/effects/abandoned-reservation.effect';
import { AbandonedReservationFacade } from '@abandoned-reservation/store/abandoned-reservation.facade';
import { SmallReservationDetailModule } from '@shared/small-reservation-detail/small-reservation-detail.module';
import { ExtraRetargetComponent } from '@abandoned-reservation/components/extra-retarget/extra-retarget.component';
import { 
  AbandonedReservationBodyComponent
} from '@abandoned-reservation/components/abandoned-reservation-body/abandoned-reservation-body.component';
import { ButtonDsComponent } from '@design-system/components/molecules/button/button.component';

export const ABANDONED_RESERVATION_REDUCER_TOKEN =
  new InjectionToken<ActionReducerMap<AbandonedReservationState>>('Feature Abandoned Reservation Reducers');

@NgModule({
  imports: [
    CommonModule,
    GlobalPipesModule,
    TranslocoModule,
    HotelSegmentDetail,
    ImageModule,
    FlightItineraryModule,
    StoreModule.forFeature(abandonedReservationFeatureName, ABANDONED_RESERVATION_REDUCER_TOKEN),
    EffectsModule.forFeature([
      AbandonedReservationEffect
    ]),
    SmallReservationDetailModule,
    ButtonDsComponent,
  ],
  exports: [
    AbandonedReservationComponent
  ],
  declarations: [
    AbandonedReservationComponent,
    AbandonedFlightReservationComponent,
    AbandonedAutoReservationComponent,
    AbandonedHotelReservationComponent,
    AbandonedReservationHeaderComponent,
    AbandonedReservationActionsComponent,
    AutoReservationComponent,
    AbandonedAirPackageReservationComponent,
    ExtraRetargetComponent,
    AbandonedReservationBodyComponent
  ],
  providers: [
    AbandonedReservationFacade,
    UserHistoryService,
    AbandonedReservationService,
    {
      provide: ABANDONED_RESERVATION_REDUCER_TOKEN,
      useValue: abandonedReservationRootReducer
    },
  ],
})
export class AbandonedReservationModule { }
